export const environment = {
    production: false,
    apiUrl: 'http://uatnew.gibl.in/php-services/fire-insurance-api/service.php'

    // apiUrl: 'http://uatnew.gibl.in/fire-insurance-api/service.php'
    // apiUrl: 'http://besthealthinsurance.co.in/service.php'
    // apiUrl: 'http://3.110.170.10/php-services/fire-insurance/service.php'
    // apiUrl: 'http://13.234.34.34/php-services/fire-insurance/service.php'
};
